import { Injectable }             from '@angular/core';
import { CanActivate, Router,
         ActivatedRouteSnapshot,
         RouterStateSnapshot }    from '@angular/router';

import {AuthService} from './auth.service'
import {AuthRouteTypes} from './auth-route-types'
import {AuthUserModel} from '../model/auth_user.model'
import { Observable ,  of } from 'rxjs';
import { map } from 'rxjs/operators';



@Injectable()

export class AuthGuard implements CanActivate {




constructor(private authService: AuthService, private router: Router) {

 
}


canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   

   // we pass a routeTypeId  to all components we want to guard
   // this helps us determine here which component it is so 
   //we know how to handle authentication for different user roles
    let routeModuleId:number=0;
    let mUser:AuthUserModel=new AuthUserModel();
    if(route.params['itemType']!=null)
        routeModuleId=parseInt(route.params['itemType'])
   
   if(this.authService.authUser)
    mUser.userId = this.authService.authUser.userId;
    else
     mUser.userId=null;

    

    if (mUser.userId!=null) { 

       console.log("Curren user : "+mUser.userId);
      // We get the User Logged In from localStorage
       let login:boolean=false;

     return this.authService.getUserHasAccessRight(mUser.userId,routeModuleId)
     .pipe(
     map(result=>{

         
       
         if(!result)
         {
              
             console.log("Authentication Failure");

             this.router.navigate(['/login']);
         }
   
        return result;

     })
    );

    }
    
    // Store the attempted URL for redirecting
    this.authService.redirectUrl = state.url;

    // Navigate to the login page
    this.router.navigate(['/login']);
     return of(false);
  }
 

}